import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 42.1" fill="currentColor" {...this.props}><path d="M.4 0C.2 0 0 .2 0 .4v15.3c0 .2.1.6.3.7l4.1 4.1c.2.2.3.1.3-.1V.4c0-.2-.2-.4-.4-.4H.4zM29 18.4c0-1.2-1-2.2-2.2-2.2H10.2c-.2 0-.6.1-.7.3l-4.1 4.1c-.2.2-.1.3.1.3h18.8v15.8c0 .2.1.3.3.1l4.1-4.1c.2-.2.3-.5.3-.7V18.4zm-5.5 19H4.7V21.6c0-.2-.1-.3-.3-.1L.3 25.6c-.2.2-.3.5-.3.7v13.6c0 1.2 1 2.2 2.2 2.2h16.6c.2 0 .6-.1.7-.3l4.1-4.1c.2-.1.1-.3-.1-.3z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/bluecyber-icon.inline.svg